<div class="app-page">
  
        @if(profile$ | async; as profile) {

        
            <h1>
                    <mat-icon style="font-size: 36px; height: 36px; width: 36px;">assignment</mat-icon>
                {{profile.Name}}
            </h1>
            <p>Tests included in profile with limits.</p>
            <button mat-raised-button  type="button" (click)="addTestOpenDialog()"  >
                <mat-icon>add</mat-icon>
                ADD TEST
            </button> &nbsp;

            <div style="display: flex; flex-wrap: wrap;">
                @for(test of profile.Tests; track test.TestId) {

                        <mat-card class="test-card">
                                            <mat-card-header>
                                                <mat-card-title>
                                                        <mat-icon >assignment_turned_in</mat-icon>
                                                    {{test.Name}}
                                                </mat-card-title>
                                                <mat-card-subtitle>[{{test.Abbreviation}}]</mat-card-subtitle>
                                            </mat-card-header>
                                            @if(findLimit(profile.TestLimits, test.TestId); as limit){

                                            
                                                <mat-card-content >
                                                    <mat-divider></mat-divider>
                                                    <!-- <label>Limits</label> -->
                                                    <div style="display:flex; flex-direction: row;" >

                                                        <div class="limit_div" >
                                                            <div class="limit_title">OK</div>
                                                            <div>{{limit.LimitOK}}</div>
                                                        </div>
                                                        <div class="limit_div" >
                                                            <div class="limit_title">Good</div>
                                                            <div>{{limit.LimitGood}}</div>
                                                        </div>
                                                        <div class="limit_div" >
                                                            <div class="limit_title">Very good</div>
                                                            <div>{{limit.LimitVeryGood}}</div>
                                                        </div>
                                                        <div class="limit_div" >
                                                            <div class="limit_title">Excellent</div>
                                                            <div>{{limit.LimitExcellent}}</div>
                                                        </div>
                                                    </div>
                                                    <mat-divider></mat-divider>
                                                    @if(limit.UseFormula==true) {   
                                                        <div display="flex" flex-direction="column" >
                                                            <div  class="limit_title">Formula</div>
                                                            <div class="formula_text">{{limit?.Formula}}</div>

                                                        </div>
                                                    }

                                                    @if(limit.UseFormula!=true && limit.LimitMultiplierTestId!=null) {
                                                        <div display="flex" flex-direction="column"  >
                                                            <div  class="limit_title">Multiplier</div>
                                                            <div class="formula_text">{{limit.LimitMultiplierTestName}}</div>
                                                        </div>
                                                    }
                                                </mat-card-content>
                                                <mat-card-actions>                        
                                                    <button matButton="outlined" (click)="editTestLimits(test, limit, profile.ProfileId, profile.Name)" aria-label="Edit Test Limits">
                                                        <mat-icon>edit</mat-icon>
                                                         EDIT LIMIT
                                                    </button>
                                                    &nbsp;&nbsp;
                                                    <button matButton="outlined" (click)="removeTest(test.TestId)" aria-label="Delete test from profile" >
                                                        <mat-icon>delete</mat-icon>
                                                         REMOVE
                                                    </button>
                                                <!--       <button mat-icon-button (click)="removeTest(test.TestId)" aria-label="Delete test from profile">
                                                        <mat-icon>delete</mat-icon>
                                                    </button> -->
                                                </mat-card-actions>
                                            }
                                            @if(test.Operator=='NO'){
                                                <div style="margin: 20px;">
                                                    NO RANKING
                                                </div>
                                                <div style="margin: 10px;">
                                                  <button matButton="outlined" (click)="removeTest(test.TestId)" aria-label="Delete test from profile" style="max-width: 100px;">
                                                      <!--   <mat-icon>delete</mat-icon> -->
                                                         REMOVE
                                                    </button>
                                                </div>
                                            }
                                        </mat-card>
                }
              
            </div>
        }
</div>

